import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Services from '../views/Services.vue'
import Privacy from '../views/Privacy.vue'
import Terms from '../views/Terms.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Home - Photo Enhancer' }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: { title: 'Services - Photo Enhancer' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: 'About Us - Photo Enhancer' }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: { title: 'Privacy Policy - Photo Enhancer' }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: { title: 'Terms of Service - Photo Enhancer' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 更新页面标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Photo Enhancer - AI Upscale'
  next()
})

export default router 